export enum PaymentStatus {
  Unknown = 'Unknown',
  NotPaid = 'Not Paid',
  PartiallyPaid = 'Partially Paid',
  FullyPaid = 'Paid',
  OverPaid = 'Over Paid'
}
